const stepperStyle = {
    hidden: { display: 'none' },
    stepText: {},
    pageBody: { background: 'transparent', flexWrap: 'noWrap' },
};

export default stepperStyle;
